export default __webpack_public_path__ + "static/runn-974ac09fd91c4a00c474163d3be0a2c5.png";